import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=6d1e92a4&"
import script from "./AppList.vue?vue&type=script&lang=js&"
export * from "./AppList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1e92a4')) {
      api.createRecord('6d1e92a4', component.options)
    } else {
      api.reload('6d1e92a4', component.options)
    }
    module.hot.accept("./AppList.vue?vue&type=template&id=6d1e92a4&", function () {
      api.rerender('6d1e92a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/settings/src/components/AppList.vue"
export default component.exports